import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import RentalAgreement from "@/components/RentalAgreement";
import { Printer } from "lucide-react";

export default function RentalAgreementPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <SEO
        title="Rental Agreement | Chestnut Hill Inn"
        description="Read the Chestnut Hill Inn Vacation Rental Agreement and house rules for Long Island, Maine."
      />

      {/* Header */}
      <header className="bg-white border-b border-stone-200 py-4 px-6 sticky top-0 z-50 print:hidden">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-serif text-xl text-[#1C1917]">
            Chestnut Hill Inn
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/about" className="text-sm text-[#78716C] hover:text-[#1C1917]">About</Link>
            <Link to="/winter-retreats" className="text-sm text-[#78716C] hover:text-[#1C1917]">Winter Retreats</Link>
            <Link to="/faq" className="text-sm text-[#78716C] hover:text-[#1C1917]">FAQ</Link>
            <Link to="/booking">
              <Button className="bg-[#134E4A] hover:bg-[#0f3d3a] text-white">Book Now</Button>
            </Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-3xl mx-auto px-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="font-serif text-3xl md:text-4xl text-[#1C1917]">Rental Agreement</h1>
              <p className="text-[#78716C] mt-1">Chestnut Hill Inn · Long Island, Maine</p>
            </div>
            <Button
              data-testid="print-agreement-btn"
              variant="outline"
              onClick={() => window.print()}
              className="print:hidden"
            >
              <Printer size={16} className="mr-2" /> Print / Save PDF
            </Button>
          </div>

          <RentalAgreement readOnly />

          <p className="text-sm text-[#78716C] mt-6 print:hidden">
            Questions about these terms? Email chestnuthillinn@gmail.com or call (603) 858-2272.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1C1917] text-white py-12 print:hidden">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h3 className="font-serif text-2xl mb-2">Chestnut Hill Inn</h3>
          <p className="text-white/60 mb-4">209 Beach Ave, Long Island, ME</p>
        </div>
      </footer>
    </div>
  );
}
